export class BaseEntity {
  Id: string;

  constructor() {}
}
